import React from 'react';

const Select = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  required,
  readOnly,
  errorText,
  className = 'mb-10',
  selectClassName,
  items,
}) => {
  return (
    <div className={`form-block ${className || ''}`}>
      {label && (
        <label htmlFor={id} className='fw-700 mb-5 mb-md-6'>
          {label}
        </label>
      )}
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        readOnly={readOnly}
        className={`form-control is-${errorText ? 'invalid' : ''} ${selectClassName || ''}`}
      >
        {placeholder && <option value=''>{placeholder}</option>}
        {items &&
          items.length &&
          items.map(({ name, value }, index) => (
            <option key={index} value={value}>
              {name}
            </option>
          ))}
      </select>
      <div className='invalid-feedback mt-5'>{errorText}</div>
    </div>
  );
};

Select.defaultProps = {
  value: '',
  onChange: () => {},
};

export default Select;
